webpackJsonp([174100216785780],{

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookRedux = __webpack_require__(38);
	
	var _LoreHookRedux2 = _interopRequireDefault(_LoreHookRedux);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookRedux2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'preloadedState'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Initial state of the Redux store. Any data you specify here will be in the store when the application starts.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: 'http://redux.js.org/docs/api/createStore.html' },
	        'http://redux.js.org/docs/api/createStore.html'
	      )
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      preloadedState: function() {\n        return {};\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-redux-config-preloaded-state-js-27d771b8991ef2199a64.js